export function canViewHiddenStores(user) {
  return user?.Role === "Admin" || user?.Role === "Moderator";
}

export function isReservationStoreVisible(store, user) {
  return (
    store?.Status === "open" &&
    (!store?.HideFromWeb || canViewHiddenStores(user))
  );
}

export function reservationStoresForCity(stores, selectedCity, position = {}) {
  if (!selectedCity) {
    return [];
  }

  return (stores || [])
    .filter((store) => store?.City === selectedCity)
    .map((store) => ({
      ...store,
      Distance: haversineDistance(
        position?.lat,
        position?.lng,
        store?.Latitude,
        store?.Longitude
      ),
    }))
    .sort((a, b) => sortableDistance(a.Distance) - sortableDistance(b.Distance));
}

function sortableDistance(distance) {
  return Number.isFinite(distance) ? distance : Number.POSITIVE_INFINITY;
}

function haversineDistance(lat1, lng1, lat2, lng2) {
  const R = 6371e3;
  const toRadians = (degrees) => degrees * (Math.PI / 180);
  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return (R * c) / 1000;
}
